import { IWatchMock } from './models/IWatchMock';
import {mockBrands} from './brand.mock';

export const mockWatches: IWatchMock[] = [
  {
    id: 1,
    name: 'Lange 1',
    brand: mockBrands[0],
    description: 'Reloj exclusivo con diseño minimalista.',
    price: 25000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['http://localhost:3000/watches/1.jpg', 'http://localhost:3000/watches/2.jpeg'],
    sellerId: 1
  },
  {
    id: 2,
    name: 'Zeitwerk',
    brand: mockBrands[0],
    description: 'Innovador con pantalla digital mecánica.',
    price: 27000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['http://localhost:3000/watches/9.jpeg', 'http://localhost:3000/watches/8.jpeg'],
    sellerId: 2
  },
  {
    id: 3,
    name: 'Saxonia',
    brand: mockBrands[0],
    description: 'Elegancia clásica en cada detalle.',
    price: 25500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['http://localhost:3000/watches/2.jpg', 'https://example.com/saxonia-2.jpg'],
    sellerId: 3
  },
  {
    id: 4,
    name: 'Datograph',
    brand: mockBrands[0],
    description: 'Cronógrafo de precisión excepcional.',
    price: 31000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['http://localhost:3000/watches/3.jpeg', 'https://example.com/datograph-2.jpg'],
    sellerId: 1
  },
  {
    id: 5,
    name: 'Cabaret',
    brand: mockBrands[0],
    description: 'Forma rectangular única y sofisticada.',
    price: 28870,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['http://localhost:3000/watches/4.jpeg', 'https://example.com/cabaret-2.jpg'],
    sellerId: 4
  },
  {
    id: 6,
    name: 'Richard Lange',
    brand: mockBrands[0],
    description: 'Homenaje a la relojería científica.',
    price: 25660,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['http://localhost:3000/watches/6.jpeg', 'https://example.com/richard-2.jpg'],
    sellerId: 5
  },
  {
    id: 7,
    name: '1815 Chronograph',
    brand: mockBrands[0],
    description: 'Estilo vintage con tecnología moderna.',
    price: 27890,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['http://localhost:3000/watches/8.jpeg', 'https://example.com/1815-2.jpg'],
    sellerId: 2
  },
  {
    id: 8,
    name: 'Lange 31',
    brand: mockBrands[0],
    description: 'Reserva de marcha de 31 días.',
    price: 28500,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['http://localhost:3000/watches/7.jpeg', 'https://example.com/lange31-2.jpg'],
    sellerId: 3
  },
  {
    id: 9,
    name: 'Tourbograph',
    brand: mockBrands[0],
    description: 'Obra maestra con tourbillon integrado.',
    price: 28000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['http://localhost:3000/watches/2.jpg', 'https://example.com/tourbograph-2.jpg'],
    sellerId: 8
  },
  {
    id: 10,
    name: 'Odysseus',
    brand: mockBrands[0],
    description: 'Deportivo y robusto, edición limitada.',
    price: 25500,
    condition: 'NEW',
    marketStatus: 'SOLD',
    iconUrl: '',
    images: ['http://localhost:3000/watches/10.jpg', 'https://example.com/odysseus-2.jpg'],
    sellerId: 9
  },
  {
    id: 11,
    name: 'Fifty Fathoms',
    brand: mockBrands[29],
    description: 'Reloj de buceo legendario.',
    price: 12000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/fifty-1.jpg', 'https://example.com/fifty-2.jpg'],
    sellerId: 4
  },
  {
    id: 12,
    name: 'Villeret Ultra-Slim',
    brand: mockBrands[29],
    description: 'Elegancia minimalista y fina.',
    price: 15000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/villeret-1.jpg', 'https://example.com/villeret-2.jpg'],
    sellerId: 8
  },
  {
    id: 13,
    name: 'Léman Flyback',
    brand: mockBrands[29],
    description: 'Cronógrafo robusto y funcional.',
    price: 18000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/leman-1.jpg', 'https://example.com/leman-2.jpg'],
    sellerId: 1
  },
  {
    id: 14,
    name: 'Villeret Moonphase',
    brand: mockBrands[29],
    description: 'Fases lunares con diseño clásico.',
    price: 20000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/moon-1.jpg', 'https://example.com/moon-2.jpg'],
    sellerId: 6
  },
  {
    id: 15,
    name: 'Le Brassus',
    brand: mockBrands[29],
    description: 'Artesanía suiza en cada detalle.',
    price: 25000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/brassus-1.jpg', 'https://example.com/brassus-2.jpg'],
    sellerId: 3
  },
  {
    id: 16,
    name: 'Fifty Fathoms Bathyscaphe',
    brand: mockBrands[29],
    description: 'Versión moderna del ícono de buceo.',
    price: 22000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/bathy-1.jpg', 'https://example.com/bathy-2.jpg'],
    sellerId: 9
  },
  {
    id: 17,
    name: 'Villeret Chronograph',
    brand: mockBrands[29],
    description: 'Precisión y estilo en movimiento.',
    price: 19000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/vchrono-1.jpg', 'https://example.com/vchrono-2.jpg'],
    sellerId: 5
  },
  {
    id: 18,
    name: 'L-Evolution Tourbillon',
    brand: mockBrands[29],
    description: 'Tourbillon de alta tecnología.',
    price: 85000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/evo-1.jpg', 'https://example.com/evo-2.jpg'],
    sellerId: 2
  },
  {
    id: 19,
    name: 'Villeret Grande Date',
    brand: mockBrands[29],
    description: 'Fecha ampliada en diseño moderno.',
    price: 30000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/gdate-1.jpg', 'https://example.com/gdate-2.jpg'],
    sellerId: 7
  },
  {
    id: 20,
    name: 'Carrousel Minute Repeater',
    brand: mockBrands[29],
    description: 'Complicación sonora de lujo.',
    price: 95000,
    condition: 'NEW',
    marketStatus: 'SOLD',
    iconUrl: '',
    images: ['https://example.com/carrousel-1.jpg', 'https://example.com/carrousel-2.jpg'],
    sellerId: 10
  },
  {
    id: 21,
    name: 'BR 01-92',
    brand: mockBrands[43],
    description: 'Diseño cuadrado inspirado en aviación.',
    price: 2500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/br01-92-1.jpg', 'https://example.com/br01-92-2.jpg'],
    sellerId: 6
  },
  {
    id: 22,
    name: 'BR 03-94 Chronograph',
    brand: mockBrands[43],
    description: 'Cronógrafo robusto para pilotos.',
    price: 3500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/br03-94-1.jpg', 'https://example.com/br03-94-2.jpg'],
    sellerId: 2
  },
  {
    id: 23,
    name: 'BR V2-92 Military',
    brand: mockBrands[43],
    description: 'Estilo militar con gran legibilidad.',
    price: 2200,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/v2-92-1.jpg', 'https://example.com/v2-92-2.jpg'],
    sellerId: 9
  },
  {
    id: 24,
    name: 'BR 05 Skeleton',
    brand: mockBrands[43],
    description: 'Esfera esqueletizada moderna.',
    price: 4500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/br05-skel-1.jpg', 'https://example.com/br05-skel-2.jpg'],
    sellerId: 4
  },
  {
    id: 25,
    name: 'BR-X1 Titanium',
    brand: mockBrands[43],
    description: 'Ligero y resistente en titanio.',
    price: 6000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/x1-titan-1.jpg', 'https://example.com/x1-titan-2.jpg'],
    sellerId: 7
  },
  {
    id: 26,
    name: 'BR V1-92 Vintage',
    brand: mockBrands[43],
    description: 'Look retro con detalles clásicos.',
    price: 2000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/v1-92-1.jpg', 'https://example.com/v1-92-2.jpg'],
    sellerId: 1
  },
  {
    id: 27,
    name: 'BR 03-92 Diver',
    brand: mockBrands[43],
    description: 'Reloj de buceo con gran resistencia.',
    price: 3200,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/diver-1.jpg', 'https://example.com/diver-2.jpg'],
    sellerId: 5
  },
  {
    id: 28,
    name: 'BR-X5 Black Steel',
    brand: mockBrands[43],
    description: 'Edición moderna en acero negro.',
    price: 7500,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/x5-black-1.jpg', 'https://example.com/x5-black-2.jpg'],
    sellerId: 3
  },
  {
    id: 29,
    name: 'BR 05 Chrono Blue',
    brand: mockBrands[43],
    description: 'Cronógrafo urbano en tono azul.',
    price: 6500,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/chrono-blue-1.jpg', 'https://example.com/chrono-blue-2.jpg'],
    sellerId: 8
  },
  {
    id: 30,
    name: 'BR V3-94 Phantom',
    brand: mockBrands[43],
    description: 'Diseño stealth totalmente negro.',
    price: 5000,
    condition: 'NEW',
    marketStatus: 'SOLD',
    iconUrl: '',
    images: ['https://example.com/phantom-1.jpg', 'https://example.com/phantom-2.jpg'],
    sellerId: 10
  },
  {
    id: 31,
    name: 'Fifty Fathoms',
    brand: mockBrands[53],
    description: 'Icónico reloj de buceo con historia.',
    price: 13000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/fifty-1.jpg', 'https://example.com/fifty-2.jpg'],
    sellerId: 3
  },
  {
    id: 32,
    name: 'Villeret Ultra-Slim',
    brand: mockBrands[53],
    description: 'Delgadez y elegancia en un solo diseño.',
    price: 16000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/villeret-1.jpg', 'https://example.com/villeret-2.jpg'],
    sellerId: 7
  },
  {
    id: 33,
    name: 'Léman Flyback',
    brand: mockBrands[53],
    description: 'Cronógrafo versátil y preciso.',
    price: 19000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/leman-1.jpg', 'https://example.com/leman-2.jpg'],
    sellerId: 1
  },
  {
    id: 34,
    name: 'Villeret Moonphase',
    brand: mockBrands[53],
    description: 'Fases lunares con toque clásico.',
    price: 21000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/moon-1.jpg', 'https://example.com/moon-2.jpg'],
    sellerId: 9
  },
  {
    id: 35,
    name: 'Le Brassus',
    brand: mockBrands[53],
    description: 'Artesanía pura en cada componente.',
    price: 24000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/brassus-1.jpg', 'https://example.com/brassus-2.jpg'],
    sellerId: 5
  },
  {
    id: 36,
    name: 'Fifty Fathoms Bathyscaphe',
    brand: mockBrands[53],
    description: 'Moderno y resistente bajo el agua.',
    price: 20000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/bathy-1.jpg', 'https://example.com/bathy-2.jpg'],
    sellerId: 2
  },
  {
    id: 37,
    name: 'Villeret Chronograph',
    brand: mockBrands[53],
    description: 'Estilo dinámico con gran precisión.',
    price: 18000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/vchrono-1.jpg', 'https://example.com/vchrono-2.jpg'],
    sellerId: 8
  },
  {
    id: 38,
    name: 'L-Evolution Tourbillon',
    brand: mockBrands[53],
    description: 'Tourbillon de vanguardia.',
    price: 90000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/evo-1.jpg', 'https://example.com/evo-2.jpg'],
    sellerId: 4
  },
  {
    id: 39,
    name: 'Villeret Grande Date',
    brand: mockBrands[53],
    description: 'Fecha grande en un diseño limpio.',
    price: 32000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/gdate-1.jpg', 'https://example.com/gdate-2.jpg'],
    sellerId: 6
  },
  {
    id: 40,
    name: 'Carrousel Minute Repeater',
    brand: mockBrands[53],
    description: 'Complicación sonora de alta gama.',
    price: 98000,
    condition: 'NEW',
    marketStatus: 'SOLD',
    iconUrl: '',
    images: ['https://example.com/carrousel-1.jpg', 'https://example.com/carrousel-2.jpg'],
    sellerId: 10
  },
  {
    id: 41,
    name: 'Navitimer',
    brand: mockBrands[64],
    description: 'Clásico de aviación con regla de cálculo.',
    price: 6000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/navitimer-1.jpg', 'https://example.com/navitimer-2.jpg'],
    sellerId: 5
  },
  {
    id: 42,
    name: 'Chronomat',
    brand: mockBrands[64],
    description: 'Cronógrafo robusto y versátil.',
    price: 7500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/chronomat-1.jpg', 'https://example.com/chronomat-2.jpg'],
    sellerId: 2
  },
  {
    id: 43,
    name: 'Superocean',
    brand: mockBrands[64],
    description: 'Reloj de buceo con gran resistencia.',
    price: 4000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/superocean-1.jpg', 'https://example.com/superocean-2.jpg'],
    sellerId: 8
  },
  {
    id: 44,
    name: 'Avenger',
    brand: mockBrands[64],
    description: 'Diseño audaz para condiciones extremas.',
    price: 5500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/avenger-1.jpg', 'https://example.com/avenger-2.jpg'],
    sellerId: 1
  },
  {
    id: 45,
    name: 'Colt Automatic',
    brand: mockBrands[64],
    description: 'Simplicidad y precisión militar.',
    price: 3500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/colt-1.jpg', 'https://example.com/colt-2.jpg'],
    sellerId: 9
  },
  {
    id: 46,
    name: 'Premier B01',
    brand: mockBrands[64],
    description: 'Elegancia con cronógrafo integrado.',
    price: 8000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/premier-1.jpg', 'https://example.com/premier-2.jpg'],
    sellerId: 4
  },
  {
    id: 47,
    name: 'Transocean',
    brand: mockBrands[64],
    description: 'Estilo retro para viajeros.',
    price: 6500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/transocean-1.jpg', 'https://example.com/transocean-2.jpg'],
    sellerId: 7
  },
  {
    id: 48,
    name: 'Navitimer 8',
    brand: mockBrands[64],
    description: 'Moderno y funcional para pilotos.',
    price: 9000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/nav8-1.jpg', 'https://example.com/nav8-2.jpg'],
    sellerId: 3
  },
  {
    id: 49,
    name: 'Superocean Heritage',
    brand: mockBrands[64],
    description: 'Homenaje al buceo clásico.',
    price: 11000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/heritage-1.jpg', 'https://example.com/heritage-2.jpg'],
    sellerId: 6
  },
  {
    id: 50,
    name: 'Chronoliner',
    brand: mockBrands[64],
    description: 'Cronógrafo con segundo huso horario.',
    price: 9500,
    condition: 'NEW',
    marketStatus: 'SOLD',
    iconUrl: '',
    images: ['https://example.com/chronoliner-1.jpg', 'https://example.com/chronoliner-2.jpg'],
    sellerId: 10
  },
  {
    id: 51,
    name: 'Tank Solo',
    brand: mockBrands[82],
    description: 'Diseño rectangular icónico y elegante.',
    price: 2500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/tank-solo-1.jpg', 'https://example.com/tank-solo-2.jpg'],
    sellerId: 4
  },
  {
    id: 52,
    name: 'Santos de Cartier',
    brand: mockBrands[82],
    description: 'Estilo aviador con líneas modernas.',
    price: 6000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/santos-1.jpg', 'https://example.com/santos-2.jpg'],
    sellerId: 9
  },
  {
    id: 53,
    name: 'Ballon Bleu',
    brand: mockBrands[82],
    description: 'Esfera redonda con corona distintiva.',
    price: 4500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/ballon-1.jpg', 'https://example.com/ballon-2.jpg'],
    sellerId: 1
  },
  {
    id: 54,
    name: 'Pasha de Cartier',
    brand: mockBrands[82],
    description: 'Reloj audaz con detalles únicos.',
    price: 7000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/pasha-1.jpg', 'https://example.com/pasha-2.jpg'],
    sellerId: 7
  },
  {
    id: 55,
    name: 'Tank Française',
    brand: mockBrands[82],
    description: 'Clásico rectangular con acabado pulido.',
    price: 3800,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/tank-fr-1.jpg', 'https://example.com/tank-fr-2.jpg'],
    sellerId: 3
  },
  {
    id: 56,
    name: 'Calibre de Cartier',
    brand: mockBrands[82],
    description: 'Robusto y sofisticado para caballeros.',
    price: 5500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/calibre-1.jpg', 'https://example.com/calibre-2.jpg'],
    sellerId: 6
  },
  {
    id: 57,
    name: 'Ronde Solo',
    brand: mockBrands[82],
    description: 'Simplicidad elegante en diseño redondo.',
    price: 3000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/ronde-1.jpg', 'https://example.com/ronde-2.jpg'],
    sellerId: 10
  },
  {
    id: 58,
    name: 'Tank Anglaise',
    brand: mockBrands[82],
    description: 'Versión moderna del Tank con corona integrada.',
    price: 8500,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/anglaise-1.jpg', 'https://example.com/anglaise-2.jpg'],
    sellerId: 2
  },
  {
    id: 59,
    name: 'Santos Dumont',
    brand: mockBrands[82],
    description: 'Homenaje al pionero de la aviación.',
    price: 9500,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/dumont-1.jpg', 'https://example.com/dumont-2.jpg'],
    sellerId: 5
  },
  {
    id: 60,
    name: 'Ballon Bleu Chronograph',
    brand: mockBrands[82],
    description: 'Cronógrafo de lujo con esfera azul.',
    price: 12000,
    condition: 'NEW',
    marketStatus: 'SOLD',
    iconUrl: '',
    images: ['https://example.com/ballon-chrono-1.jpg', 'https://example.com/ballon-chrono-2.jpg'],
    sellerId: 8
  },
  {
    id: 61,
    name: 'Mille Miglia',
    brand: mockBrands[98],
    description: 'Reloj inspirado en las carreras clásicas.',
    price: 5500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/mille-1.jpg', 'https://example.com/mille-2.jpg'],
    sellerId: 3
  },
  {
    id: 62,
    name: 'Happy Sport',
    brand: mockBrands[98],
    description: 'Diseño juguetón con diamantes móviles.',
    price: 7000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/happy-1.jpg', 'https://example.com/happy-2.jpg'],
    sellerId: 8
  },
  {
    id: 63,
    name: 'L.U.C XP',
    brand: mockBrands[98],
    description: 'Elegancia ultradelgada y refinada.',
    price: 9000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/luc-xp-1.jpg', 'https://example.com/luc-xp-2.jpg'],
    sellerId: 1
  },
  {
    id: 64,
    name: 'Imperiale',
    brand: mockBrands[98],
    description: 'Sofisticación con detalles imperiales.',
    price: 6500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/imperiale-1.jpg', 'https://example.com/imperiale-2.jpg'],
    sellerId: 6
  },
  {
    id: 65,
    name: 'Alpine Eagle',
    brand: mockBrands[98],
    description: 'Deportivo y robusto con estilo alpino.',
    price: 11000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/alpine-1.jpg', 'https://example.com/alpine-2.jpg'],
    sellerId: 4
  },
  {
    id: 66,
    name: 'L.U.C Chrono One',
    brand: mockBrands[98],
    description: 'Cronógrafo de lujo con gran precisión.',
    price: 12000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/chrono-one-1.jpg', 'https://example.com/chrono-one-2.jpg'],
    sellerId: 9
  },
  {
    id: 67,
    name: 'Classic Racing',
    brand: mockBrands[98],
    description: 'Estilo retro para amantes de los autos.',
    price: 8000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/classic-1.jpg', 'https://example.com/classic-2.jpg'],
    sellerId: 2
  },
  {
    id: 68,
    name: 'L.U.C Tourbillon',
    brand: mockBrands[98],
    description: 'Tourbillon de alta complicación.',
    price: 85000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/tourbillon-1.jpg', 'https://example.com/tourbillon-2.jpg'],
    sellerId: 7
  },
  {
    id: 69,
    name: 'Happy Diamonds',
    brand: mockBrands[98],
    description: 'Diamantes flotantes en un diseño único.',
    price: 15000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/diamonds-1.jpg', 'https://example.com/diamonds-2.jpg'],
    sellerId: 5
  },
  {
    id: 70,
    name: 'Mille Miglia GTS',
    brand: mockBrands[98],
    description: 'Velocidad y lujo en una pieza exclusiva.',
    price: 13000,
    condition: 'NEW',
    marketStatus: 'SOLD',
    iconUrl: '',
    images: ['https://example.com/gts-1.jpg', 'https://example.com/gts-2.jpg'],
    sellerId: 10
  },
  {
    id: 71,
    name: 'Regulator Classic',
    brand: mockBrands[103],
    description: 'Diseño regulador con estilo atemporal.',
    price: 4000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/reg-classic-1.jpg', 'https://example.com/reg-classic-2.jpg'],
    sellerId: 7
  },
  {
    id: 72,
    name: 'Sirius Chronograph',
    brand: mockBrands[103],
    description: 'Cronógrafo elegante con detalles finos.',
    price: 6500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/sirius-chrono-1.jpg', 'https://example.com/sirius-chrono-2.jpg'],
    sellerId: 2
  },
  {
    id: 73,
    name: 'Timemaster',
    brand: mockBrands[103],
    description: 'Robusto y funcional para el día a día.',
    price: 3500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/timemaster-1.jpg', 'https://example.com/timemaster-2.jpg'],
    sellerId: 9
  },
  {
    id: 74,
    name: 'Opus Chronograph',
    brand: mockBrands[103],
    description: 'Esfera esqueletizada con cronógrafo.',
    price: 8000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/opus-1.jpg', 'https://example.com/opus-2.jpg'],
    sellerId: 4
  },
  {
    id: 75,
    name: 'Lunar Chronograph',
    brand: mockBrands[103],
    description: 'Fases lunares con diseño moderno.',
    price: 7000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/lunar-1.jpg', 'https://example.com/lunar-2.jpg'],
    sellerId: 1
  },
  {
    id: 76,
    name: 'Regulator Manufacture',
    brand: mockBrands[103],
    description: 'Artesanía suiza en un regulador único.',
    price: 5500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/reg-manuf-1.jpg', 'https://example.com/reg-manuf-2.jpg'],
    sellerId: 6
  },
  {
    id: 77,
    name: 'Kairos',
    brand: mockBrands[103],
    description: 'Clásico con esfera guilloché detallada.',
    price: 4500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/kairos-1.jpg', 'https://example.com/kairos-2.jpg'],
    sellerId: 3
  },
  {
    id: 78,
    name: 'Flying Grand Regulator',
    brand: mockBrands[103],
    description: 'Regulador moderno con gran presencia.',
    price: 12000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/flying-1.jpg', 'https://example.com/flying-2.jpg'],
    sellerId: 8
  },
  {
    id: 79,
    name: 'Sirius Retrograde',
    brand: mockBrands[103],
    description: 'Complicación retrógrada sofisticada.',
    price: 9500,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/retro-1.jpg', 'https://example.com/retro-2.jpg'],
    sellerId: 5
  },
  {
    id: 80,
    name: 'Opus Skeleton',
    brand: mockBrands[103],
    description: 'Esfera esqueletizada de lujo.',
    price: 10000,
    condition: 'NEW',
    marketStatus: 'SOLD',
    iconUrl: '',
    images: ['https://example.com/opus-skel-1.jpg', 'https://example.com/opus-skel-2.jpg'],
    sellerId: 10
  },
  {
    id: 81,
    name: 'Vanguard',
    brand: mockBrands[189],
    description: 'Diseño audaz con curvas distintivas.',
    price: 7500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/vanguard-1.jpg', 'https://example.com/vanguard-2.jpg'],
    sellerId: 6
  },
  {
    id: 82,
    name: 'Master Square',
    brand: mockBrands[189],
    description: 'Forma cuadrada con elegancia única.',
    price: 9000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/master-square-1.jpg', 'https://example.com/master-square-2.jpg'],
    sellerId: 3
  },
  {
    id: 83,
    name: 'Cintree Curvex',
    brand: mockBrands[189],
    description: 'Caja curvada icónica de la marca.',
    price: 8500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/curvex-1.jpg', 'https://example.com/curvex-2.jpg'],
    sellerId: 8
  },
  {
    id: 84,
    name: 'Conquistador',
    brand: mockBrands[189],
    description: 'Estilo robusto con carácter atrevido.',
    price: 6500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/conquistador-1.jpg', 'https://example.com/conquistador-2.jpg'],
    sellerId: 1
  },
  {
    id: 85,
    name: 'Long Island',
    brand: mockBrands[189],
    description: 'Rectangular con diseño Art Déco.',
    price: 8000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/long-island-1.jpg', 'https://example.com/long-island-2.jpg'],
    sellerId: 9
  },
  {
    id: 86,
    name: 'Aeternitas',
    brand: mockBrands[189],
    description: 'Complicación extrema en perfecto estado.',
    price: 25000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/aeternitas-1.jpg', 'https://example.com/aeternitas-2.jpg'],
    sellerId: 4
  },
  {
    id: 87,
    name: 'Crazy Hours',
    brand: mockBrands[189],
    description: 'Horas desordenadas con toque juguetón.',
    price: 12000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/crazy-1.jpg', 'https://example.com/crazy-2.jpg'],
    sellerId: 7
  },
  {
    id: 88,
    name: 'Vanguard Yachting',
    brand: mockBrands[189],
    description: 'Náutico y lujoso con detalles marinos.',
    price: 15000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/yachting-1.jpg', 'https://example.com/yachting-2.jpg'],
    sellerId: 2
  },
  {
    id: 89,
    name: 'Master Banker',
    brand: mockBrands[189],
    description: 'Tres husos horarios para el viajero.',
    price: 18000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/banker-1.jpg', 'https://example.com/banker-2.jpg'],
    sellerId: 5
  },
  {
    id: 90,
    name: 'Giga Tourbillon',
    brand: mockBrands[189],
    description: 'Tourbillon masivo de alta complicación.',
    price: 95000,
    condition: 'NEW',
    marketStatus: 'SOLD',
    iconUrl: '',
    images: ['https://example.com/giga-1.jpg', 'https://example.com/giga-2.jpg'],
    sellerId: 10
  },
  {
    id: 91,
    name: 'Vintage 1945',
    brand: mockBrands[204],
    description: 'Diseño rectangular con inspiración retro.',
    price: 8500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/vintage-1945-1.jpg', 'https://example.com/vintage-1945-2.jpg'],
    sellerId: 5
  },
  {
    id: 92,
    name: 'Laureato',
    brand: mockBrands[204],
    description: 'Deportivo y elegante con bisel octogonal.',
    price: 10000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/laureato-1.jpg', 'https://example.com/laureato-2.jpg'],
    sellerId: 2
  },
  {
    id: 93,
    name: 'Bridges Planetarium',
    brand: mockBrands[204],
    description: 'Complicación astronómica impresionante.',
    price: 45000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/planetarium-1.jpg', 'https://example.com/planetarium-2.jpg'],
    sellerId: 8
  },
  {
    id: 94,
    name: '1966 Chronograph',
    brand: mockBrands[204],
    description: 'Cronógrafo clásico con líneas puras.',
    price: 12000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/1966-chrono-1.jpg', 'https://example.com/1966-chrono-2.jpg'],
    sellerId: 1
  },
  {
    id: 95,
    name: 'Hawk Sea',
    brand: mockBrands[204],
    description: 'Reloj de buceo robusto y funcional.',
    price: 9500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/hawk-sea-1.jpg', 'https://example.com/hawk-sea-2.jpg'],
    sellerId: 7
  },
  {
    id: 96,
    name: 'Richeville',
    brand: mockBrands[204],
    description: 'Estilo vintage con caja curvada.',
    price: 7000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/richeville-1.jpg', 'https://example.com/richeville-2.jpg'],
    sellerId: 4
  },
  {
    id: 97,
    name: 'WW.TC',
    brand: mockBrands[204],
    description: 'Horas mundiales para el viajero moderno.',
    price: 13000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/wwtc-1.jpg', 'https://example.com/wwtc-2.jpg'],
    sellerId: 9
  },
  {
    id: 98,
    name: 'Laureato Evo3',
    brand: mockBrands[204],
    description: 'Evolución moderna del diseño icónico.',
    price: 15000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/evo3-1.jpg', 'https://example.com/evo3-2.jpg'],
    sellerId: 3
  },
  {
    id: 99,
    name: 'Tri-Axial Tourbillon',
    brand: mockBrands[204],
    description: 'Tourbillon de tres ejes de alta precisión.',
    price: 80000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/tri-axial-1.jpg', 'https://example.com/tri-axial-2.jpg'],
    sellerId: 6
  },
  {
    id: 100,
    name: 'Bridges Golden Bridge',
    brand: mockBrands[204],
    description: 'Puente dorado con movimiento visible.',
    price: 25000,
    condition: 'NEW',
    marketStatus: 'SOLD',
    iconUrl: '',
    images: ['https://example.com/golden-bridge-1.jpg', 'https://example.com/golden-bridge-2.jpg'],
    sellerId: 10
  },
  {
    id: 101,
    name: 'Senator Excellence',
    brand: mockBrands[206],
    description: 'Elegancia clásica con precisión alemana.',
    price: 9000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/senator-exc-1.jpg', 'https://example.com/senator-exc-2.jpg'],
    sellerId: 4
  },
  {
    id: 102,
    name: 'PanoMaticLunar',
    brand: mockBrands[206],
    description: 'Fases lunares con diseño asimétrico.',
    price: 11000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/panomatic-1.jpg', 'https://example.com/panomatic-2.jpg'],
    sellerId: 8
  },
  {
    id: 103,
    name: 'Sixties Panorama Date',
    brand: mockBrands[206],
    description: 'Estilo retro con fecha grande.',
    price: 7500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/sixties-1.jpg', 'https://example.com/sixties-2.jpg'],
    sellerId: 1
  },
  {
    id: 104,
    name: 'Senator Chronograph',
    brand: mockBrands[206],
    description: 'Cronógrafo sofisticado y funcional.',
    price: 13000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/senator-chrono-1.jpg', 'https://example.com/senator-chrono-2.jpg'],
    sellerId: 6
  },
  {
    id: 105,
    name: 'PanoReserve',
    brand: mockBrands[206],
    description: 'Reserva de marcha con diseño único.',
    price: 10000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/pano-reserve-1.jpg', 'https://example.com/pano-reserve-2.jpg'],
    sellerId: 3
  },
  {
    id: 106,
    name: 'SeaQ',
    brand: mockBrands[206],
    description: 'Reloj de buceo robusto y elegante.',
    price: 8500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/seaq-1.jpg', 'https://example.com/seaq-2.jpg'],
    sellerId: 9
  },
  {
    id: 107,
    name: 'PanoInverse',
    brand: mockBrands[206],
    description: 'Movimiento invertido a la vista.',
    price: 12000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/pano-inverse-1.jpg', 'https://example.com/pano-inverse-2.jpg'],
    sellerId: 5
  },
  {
    id: 108,
    name: 'Senator Cosmopolite',
    brand: mockBrands[206],
    description: 'Horas mundiales para el viajero global.',
    price: 25000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/cosmopolite-1.jpg', 'https://example.com/cosmopolite-2.jpg'],
    sellerId: 7
  },
  {
    id: 109,
    name: 'PanoMatic Chrono',
    brand: mockBrands[206],
    description: 'Cronógrafo con diseño asimétrico moderno.',
    price: 15000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/pano-chrono-1.jpg', 'https://example.com/pano-chrono-2.jpg'],
    sellerId: 2
  },
  {
    id: 110,
    name: 'SeaQ Panorama Date',
    brand: mockBrands[206],
    description: 'Buceo de lujo con fecha ampliada.',
    price: 13000,
    condition: 'NEW',
    marketStatus: 'SOLD',
    iconUrl: '',
    images: ['https://example.com/seaq-date-1.jpg', 'https://example.com/seaq-date-2.jpg'],
    sellerId: 10
  },
  {
    id: 111,
    name: 'Big Bang Unico',
    brand: mockBrands[240],
    description: 'Diseño audaz con cronógrafo integrado.',
    price: 15000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/unico-1.jpg', 'https://example.com/unico-2.jpg'],
    sellerId: 3
  },
  {
    id: 112,
    name: 'Classic Fusion',
    brand: mockBrands[240],
    description: 'Elegancia minimalista con estilo moderno.',
    price: 8000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/fusion-1.jpg', 'https://example.com/fusion-2.jpg'],
    sellerId: 7
  },
  {
    id: 113,
    name: 'Spirit of Big Bang',
    brand: mockBrands[240],
    description: 'Forma tonneau con espíritu atrevido.',
    price: 18000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/spirit-1.jpg', 'https://example.com/spirit-2.jpg'],
    sellerId: 1
  },
  {
    id: 114,
    name: 'Big Bang Sang Bleu',
    brand: mockBrands[240],
    description: 'Arte geométrico en una pieza única.',
    price: 22000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/sang-bleu-1.jpg', 'https://example.com/sang-bleu-2.jpg'],
    sellerId: 9
  },
  {
    id: 115,
    name: 'King Power',
    brand: mockBrands[240],
    description: 'Robusto y poderoso con gran presencia.',
    price: 14000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/king-1.jpg', 'https://example.com/king-2.jpg'],
    sellerId: 5
  },
  {
    id: 116,
    name: 'Big Bang Ferrari',
    brand: mockBrands[240],
    description: 'Diseño inspirado en la velocidad.',
    price: 25000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/ferrari-1.jpg', 'https://example.com/ferrari-2.jpg'],
    sellerId: 2
  },
  {
    id: 117,
    name: 'Techframe',
    brand: mockBrands[240],
    description: 'Innovación técnica en titanio.',
    price: 20000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/techframe-1.jpg', 'https://example.com/techframe-2.jpg'],
    sellerId: 8
  },
  {
    id: 118,
    name: 'Big Bang Tourbillon',
    brand: mockBrands[240],
    description: 'Tourbillon de lujo con materiales modernos.',
    price: 85000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/tourbillon-1.jpg', 'https://example.com/tourbillon-2.jpg'],
    sellerId: 4
  },
  {
    id: 119,
    name: 'Classic Fusion Aerofusion',
    brand: mockBrands[240],
    description: 'Esfera esqueletizada con estilo ligero.',
    price: 12000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/aerofusion-1.jpg', 'https://example.com/aerofusion-2.jpg'],
    sellerId: 6
  },
  {
    id: 120,
    name: 'Big Bang One Click',
    brand: mockBrands[240],
    description: 'Versátil con correas intercambiables.',
    price: 18000,
    condition: 'NEW',
    marketStatus: 'SOLD',
    iconUrl: '',
    images: ['https://example.com/one-click-1.jpg', 'https://example.com/one-click-2.jpg'],
    sellerId: 10
  },
  {
    id: 121,
    name: 'Pilot’s Watch Mark XVIII',
    brand: mockBrands[250],
    description: 'Clásico de aviación con legibilidad superior.',
    price: 4500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/mark-xviii-1.jpg', 'https://example.com/mark-xviii-2.jpg'],
    sellerId: 2
  },
  {
    id: 122,
    name: 'Portugieser Chronograph',
    brand: mockBrands[250],
    description: 'Cronógrafo elegante con diseño náutico.',
    price: 8000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/port-chrono-1.jpg', 'https://example.com/port-chrono-2.jpg'],
    sellerId: 7
  },
  {
    id: 123,
    name: 'Aquatimer',
    brand: mockBrands[250],
    description: 'Reloj de buceo con bisel giratorio.',
    price: 6000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/aquatimer-1.jpg', 'https://example.com/aquatimer-2.jpg'],
    sellerId: 9
  },
  {
    id: 124,
    name: 'Big Pilot',
    brand: mockBrands[250],
    description: 'Gran tamaño con estilo aviador.',
    price: 11000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/big-pilot-1.jpg', 'https://example.com/big-pilot-2.jpg'],
    sellerId: 4
  },
  {
    id: 125,
    name: 'Portofino Automatic',
    brand: mockBrands[250],
    description: 'Simplicidad clásica para ocasiones formales.',
    price: 5000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/portofino-1.jpg', 'https://example.com/portofino-2.jpg'],
    sellerId: 1
  },
  {
    id: 126,
    name: 'Da Vinci Perpetual',
    brand: mockBrands[250],
    description: 'Calendario perpetuo con diseño refinado.',
    price: 20000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/da-vinci-1.jpg', 'https://example.com/da-vinci-2.jpg'],
    sellerId: 6
  },
  {
    id: 127,
    name: 'Ingenieur',
    brand: mockBrands[250],
    description: 'Robusto y técnico para ingenieros.',
    price: 7000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/ingenieur-1.jpg', 'https://example.com/ingenieur-2.jpg'],
    sellerId: 3
  },
  {
    id: 128,
    name: 'Pilot’s Watch Top Gun',
    brand: mockBrands[250],
    description: 'Edición militar en cerámica negra.',
    price: 12000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/top-gun-1.jpg', 'https://example.com/top-gun-2.jpg'],
    sellerId: 8
  },
  {
    id: 129,
    name: 'Portugieser Yacht Club',
    brand: mockBrands[250],
    description: 'Cronógrafo náutico de lujo.',
    price: 15000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/yacht-1.jpg', 'https://example.com/yacht-2.jpg'],
    sellerId: 5
  },
  {
    id: 130,
    name: 'Pilot’s Watch Double Chrono',
    brand: mockBrands[250],
    description: 'Doble cronógrafo para aviadores.',
    price: 13000,
    condition: 'NEW',
    marketStatus: 'SOLD',
    iconUrl: '',
    images: ['https://example.com/double-chrono-1.jpg', 'https://example.com/double-chrono-2.jpg'],
    sellerId: 10
  },
  {
    id: 131,
    name: 'Reverso Classic',
    brand: mockBrands[254],
    description: 'Icónico reloj reversible con estilo Art Déco.',
    price: 6000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/reverso-1.jpg', 'https://example.com/reverso-2.jpg'],
    sellerId: 9
  },
  {
    id: 132,
    name: 'Master Ultra Thin',
    brand: mockBrands[254],
    description: 'Delgadez extrema con elegancia pura.',
    price: 8000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/ultra-thin-1.jpg', 'https://example.com/ultra-thin-2.jpg'],
    sellerId: 4
  },
  {
    id: 133,
    name: 'Memovox Polaris',
    brand: mockBrands[254],
    description: 'Reloj con alarma de inspiración vintage.',
    price: 10000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/memovox-1.jpg', 'https://example.com/memovox-2.jpg'],
    sellerId: 1
  },
  {
    id: 134,
    name: 'Rendez-Vous',
    brand: mockBrands[254],
    description: 'Femenino y sofisticado con detalles finos.',
    price: 9000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/rendez-1.jpg', 'https://example.com/rendez-2.jpg'],
    sellerId: 6
  },
  {
    id: 135,
    name: 'Master Control',
    brand: mockBrands[254],
    description: 'Clásico con precisión certificada.',
    price: 7000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/master-1.jpg', 'https://example.com/master-2.jpg'],
    sellerId: 3
  },
  {
    id: 136,
    name: 'Duomètre',
    brand: mockBrands[254],
    description: 'Doble mecanismo con diseño innovador.',
    price: 25000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/duometre-1.jpg', 'https://example.com/duometre-2.jpg'],
    sellerId: 8
  },
  {
    id: 137,
    name: 'Geophysic',
    brand: mockBrands[254],
    description: 'Reloj técnico con inspiración científica.',
    price: 12000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/geophysic-1.jpg', 'https://example.com/geophysic-2.jpg'],
    sellerId: 5
  },
  {
    id: 138,
    name: 'Reverso Tribute',
    brand: mockBrands[254],
    description: 'Homenaje al Reverso con acabados modernos.',
    price: 13000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/tribute-1.jpg', 'https://example.com/tribute-2.jpg'],
    sellerId: 2
  },
  {
    id: 139,
    name: 'Master Grande Tradition',
    brand: mockBrands[254],
    description: 'Complicaciones clásicas de alta relojería.',
    price: 35000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/grande-1.jpg', 'https://example.com/grande-2.jpg'],
    sellerId: 7
  },
  {
    id: 140,
    name: 'Hybris Mechanica',
    brand: mockBrands[254],
    description: 'Obra maestra de complicaciones extremas.',
    price: 75000,
    condition: 'NEW',
    marketStatus: 'SOLD',
    iconUrl: '',
    images: ['https://example.com/hybris-1.jpg', 'https://example.com/hybris-2.jpg'],
    sellerId: 10
  },
  {
    id: 141,
    name: 'Heritage Classic',
    brand: mockBrands[297],
    description: 'Diseño retro con elegancia atemporal.',
    price: 2000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/heritage-1.jpg', 'https://example.com/heritage-2.jpg'],
    sellerId: 6
  },
  {
    id: 142,
    name: 'Master Collection',
    brand: mockBrands[297],
    description: 'Clásico con complicaciones refinadas.',
    price: 2500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/master-1.jpg', 'https://example.com/master-2.jpg'],
    sellerId: 2
  },
  {
    id: 143,
    name: 'HydroConquest',
    brand: mockBrands[297],
    description: 'Reloj de buceo con gran resistencia.',
    price: 1500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/hydro-1.jpg', 'https://example.com/hydro-2.jpg'],
    sellerId: 9
  },
  {
    id: 144,
    name: 'Conquest Chronograph',
    brand: mockBrands[297],
    description: 'Cronógrafo deportivo y funcional.',
    price: 3000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/conquest-1.jpg', 'https://example.com/conquest-2.jpg'],
    sellerId: 4
  },
  {
    id: 145,
    name: 'Elegant Collection',
    brand: mockBrands[297],
    description: 'Simplicidad sofisticada para cualquier ocasión.',
    price: 1800,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/elegant-1.jpg', 'https://example.com/elegant-2.jpg'],
    sellerId: 7
  },
  {
    id: 146,
    name: 'Spirit',
    brand: mockBrands[297],
    description: 'Estilo aviador con detalles modernos.',
    price: 2200,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/spirit-1.jpg', 'https://example.com/spirit-2.jpg'],
    sellerId: 1
  },
  {
    id: 147,
    name: 'Record',
    brand: mockBrands[297],
    description: 'Certificado COSC con diseño limpio.',
    price: 2700,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/record-1.jpg', 'https://example.com/record-2.jpg'],
    sellerId: 5
  },
  {
    id: 148,
    name: 'Heritage Military',
    brand: mockBrands[297],
    description: 'Inspiración militar con acabado vintage.',
    price: 3500,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/military-1.jpg', 'https://example.com/military-2.jpg'],
    sellerId: 8
  },
  {
    id: 149,
    name: 'Master Moonphase',
    brand: mockBrands[297],
    description: 'Fases lunares con estilo clásico.',
    price: 4000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/moonphase-1.jpg', 'https://example.com/moonphase-2.jpg'],
    sellerId: 3
  },
  {
    id: 150,
    name: 'Conquest V.H.P.',
    brand: mockBrands[297],
    description: 'Alta precisión con tecnología moderna.',
    price: 3200,
    condition: 'NEW',
    marketStatus: 'SOLD',
    iconUrl: '',
    images: ['https://example.com/vhp-1.jpg', 'https://example.com/vhp-2.jpg'],
    sellerId: 10
  },
  {
    id: 151,
    name: 'Aikon Automatic',
    brand: mockBrands[322],
    description: 'Diseño moderno con gran versatilidad.',
    price: 1800,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/aikon-1.jpg', 'https://example.com/aikon-2.jpg'],
    sellerId: 5
  },
  {
    id: 152,
    name: 'Masterpiece Gravity',
    brand: mockBrands[322],
    description: 'Innovación con movimiento visible.',
    price: 6500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/gravity-1.jpg', 'https://example.com/gravity-2.jpg'],
    sellerId: 9
  },
  {
    id: 153,
    name: 'Pontos S Diver',
    brand: mockBrands[322],
    description: 'Reloj de buceo con estilo retro.',
    price: 2200,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/pontos-1.jpg', 'https://example.com/pontos-2.jpg'],
    sellerId: 2
  },
  {
    id: 154,
    name: 'Eliros Chronograph',
    brand: mockBrands[322],
    description: 'Cronógrafo elegante y funcional.',
    price: 1500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/eliros-1.jpg', 'https://example.com/eliros-2.jpg'],
    sellerId: 7
  },
  {
    id: 155,
    name: 'Les Classiques',
    brand: mockBrands[322],
    description: 'Clásico atemporal para ocasiones especiales.',
    price: 1200,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/classiques-1.jpg', 'https://example.com/classiques-2.jpg'],
    sellerId: 4
  },
  {
    id: 156,
    name: 'Masterpiece Moonphase',
    brand: mockBrands[322],
    description: 'Fases lunares con diseño sofisticado.',
    price: 3000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/moon-1.jpg', 'https://example.com/moon-2.jpg'],
    sellerId: 1
  },
  {
    id: 157,
    name: 'Aikon Chronograph',
    brand: mockBrands[322],
    description: 'Cronógrafo deportivo con gran presencia.',
    price: 2000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/aikon-chrono-1.jpg', 'https://example.com/aikon-chrono-2.jpg'],
    sellerId: 6
  },
  {
    id: 158,
    name: 'Masterpiece Skeleton',
    brand: mockBrands[322],
    description: 'Esfera esqueletizada con arte moderno.',
    price: 8000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/skeleton-1.jpg', 'https://example.com/skeleton-2.jpg'],
    sellerId: 3
  },
  {
    id: 159,
    name: 'Pontos Day-Date',
    brand: mockBrands[322],
    description: 'Funcionalidad clásica con día y fecha.',
    price: 2500,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/day-date-1.jpg', 'https://example.com/day-date-2.jpg'],
    sellerId: 8
  },
  {
    id: 160,
    name: 'Aikon Titanium',
    brand: mockBrands[322],
    description: 'Ligero y resistente en titanio.',
    price: 3200,
    condition: 'NEW',
    marketStatus: 'SOLD',
    iconUrl: '',
    images: ['https://example.com/titanium-1.jpg', 'https://example.com/titanium-2.jpg'],
    sellerId: 10
  },
  {
    id: 161,
    name: 'Speedmaster Professional',
    brand: mockBrands[370],
    description: 'Icónico cronógrafo lunar.',
    price: 5500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/speedmaster-1.jpg', 'https://example.com/speedmaster-2.jpg'],
    sellerId: 7
  },
  {
    id: 162,
    name: 'Seamaster Diver 300M',
    brand: mockBrands[370],
    description: 'Reloj de buceo con estilo James Bond.',
    price: 4500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/seamaster-1.jpg', 'https://example.com/seamaster-2.jpg'],
    sellerId: 3
  },
  {
    id: 163,
    name: 'Constellation',
    brand: mockBrands[370],
    description: 'Elegancia clásica con garras distintivas.',
    price: 4000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/constellation-1.jpg', 'https://example.com/constellation-2.jpg'],
    sellerId: 9
  },
  {
    id: 164,
    name: 'De Ville Prestige',
    brand: mockBrands[370],
    description: 'Simplicidad refinada para ocasiones formales.',
    price: 3500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/de-ville-1.jpg', 'https://example.com/de-ville-2.jpg'],
    sellerId: 1
  },
  {
    id: 165,
    name: 'Speedmaster Racing',
    brand: mockBrands[370],
    description: 'Cronógrafo inspirado en la velocidad.',
    price: 6000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/racing-1.jpg', 'https://example.com/racing-2.jpg'],
    sellerId: 5
  },
  {
    id: 166,
    name: 'Seamaster Aqua Terra',
    brand: mockBrands[370],
    description: 'Versátil para tierra y mar.',
    price: 5000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/aqua-terra-1.jpg', 'https://example.com/aqua-terra-2.jpg'],
    sellerId: 2
  },
  {
    id: 167,
    name: 'Planet Ocean',
    brand: mockBrands[370],
    description: 'Buceo profesional con gran resistencia.',
    price: 6500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/planet-1.jpg', 'https://example.com/planet-2.jpg'],
    sellerId: 8
  },
  {
    id: 168,
    name: 'Speedmaster Moonwatch',
    brand: mockBrands[370],
    description: 'Edición moderna del reloj lunar.',
    price: 8000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/moonwatch-1.jpg', 'https://example.com/moonwatch-2.jpg'],
    sellerId: 4
  },
  {
    id: 169,
    name: 'Seamaster Railmaster',
    brand: mockBrands[370],
    description: 'Antimagnético con diseño industrial.',
    price: 7000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/railmaster-1.jpg', 'https://example.com/railmaster-2.jpg'],
    sellerId: 6
  },
  {
    id: 170,
    name: 'Constellation Globemaster',
    brand: mockBrands[370],
    description: 'Certificación Master Chronometer.',
    price: 9000,
    condition: 'NEW',
    marketStatus: 'SOLD',
    iconUrl: '',
    images: ['https://example.com/globemaster-1.jpg', 'https://example.com/globemaster-2.jpg'],
    sellerId: 10
  },
  {
    id: 171,
    name: 'Luminor Marina',
    brand: mockBrands[379],
    description: 'Clásico con corona distintiva.',
    price: 6000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/luminor-marina-1.jpg', 'https://example.com/luminor-marina-2.jpg'],
    sellerId: 4
  },
  {
    id: 172,
    name: 'Radiomir 1940',
    brand: mockBrands[379],
    description: 'Estilo vintage con diseño robusto.',
    price: 7500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/radiomir-1940-1.jpg', 'https://example.com/radiomir-1940-2.jpg'],
    sellerId: 9
  },
  {
    id: 173,
    name: 'Submersible',
    brand: mockBrands[379],
    description: 'Reloj de buceo con gran resistencia.',
    price: 8500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/submersible-1.jpg', 'https://example.com/submersible-2.jpg'],
    sellerId: 2
  },
  {
    id: 174,
    name: 'Luminor Due',
    brand: mockBrands[379],
    description: 'Versión delgada y elegante.',
    price: 6500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/luminor-due-1.jpg', 'https://example.com/luminor-due-2.jpg'],
    sellerId: 7
  },
  {
    id: 175,
    name: 'Luminor GMT',
    brand: mockBrands[379],
    description: 'Segundo huso horario con estilo náutico.',
    price: 9000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/luminor-gmt-1.jpg', 'https://example.com/luminor-gmt-2.jpg'],
    sellerId: 1
  },
  {
    id: 176,
    name: 'Radiomir California',
    brand: mockBrands[379],
    description: 'Esfera única con números mixtos.',
    price: 8000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/california-1.jpg', 'https://example.com/california-2.jpg'],
    sellerId: 5
  },
  {
    id: 177,
    name: 'Luminor Chrono',
    brand: mockBrands[379],
    description: 'Cronógrafo robusto con gran presencia.',
    price: 10000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/luminor-chrono-1.jpg', 'https://example.com/luminor-chrono-2.jpg'],
    sellerId: 8
  },
  {
    id: 178,
    name: 'Luminor 1950',
    brand: mockBrands[379],
    description: 'Diseño clásico con acabado moderno.',
    price: 12000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/luminor-1950-1.jpg', 'https://example.com/luminor-1950-2.jpg'],
    sellerId: 3
  },
  {
    id: 179,
    name: 'Submersible Bronzo',
    brand: mockBrands[379],
    description: 'Bronce patinado para buceo de lujo.',
    price: 18000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/bronzo-1.jpg', 'https://example.com/bronzo-2.jpg'],
    sellerId: 6
  },
  {
    id: 180,
    name: 'Radiomir 8 Days',
    brand: mockBrands[379],
    description: 'Reserva de marcha de 8 días.',
    price: 14000,
    condition: 'NEW',
    marketStatus: 'SOLD',
    iconUrl: '',
    images: ['https://example.com/radiomir-8-1.jpg', 'https://example.com/radiomir-8-2.jpg'],
    sellerId: 10
  },
  {
    id: 181,
    name: 'Nautilus',
    brand: mockBrands[381],
    description: 'Icónico diseño deportivo de lujo.',
    price: 40000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/nautilus-1.jpg', 'https://example.com/nautilus-2.jpg'],
    sellerId: 7
  },
  {
    id: 182,
    name: 'Aquanaut',
    brand: mockBrands[381],
    description: 'Elegancia moderna con correa de caucho.',
    price: 35000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/aquanaut-1.jpg', 'https://example.com/aquanaut-2.jpg'],
    sellerId: 2
  },
  {
    id: 183,
    name: 'Calatrava',
    brand: mockBrands[381],
    description: 'Clásico atemporal para ocasiones formales.',
    price: 25000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/calatrava-1.jpg', 'https://example.com/calatrava-2.jpg'],
    sellerId: 9
  },
  {
    id: 184,
    name: 'World Time',
    brand: mockBrands[381],
    description: 'Horas mundiales con esfera detallada.',
    price: 45000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/world-time-1.jpg', 'https://example.com/world-time-2.jpg'],
    sellerId: 4
  },
  {
    id: 185,
    name: 'Grand Complications',
    brand: mockBrands[381],
    description: 'Alta relojería con múltiples funciones.',
    price: 150000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/grand-comp-1.jpg', 'https://example.com/grand-comp-2.jpg'],
    sellerId: 1
  },
  {
    id: 186,
    name: 'Twenty~4',
    brand: mockBrands[381],
    description: 'Diseño femenino con acabado sofisticado.',
    price: 30000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/twenty-4-1.jpg', 'https://example.com/twenty-4-2.jpg'],
    sellerId: 6
  },
  {
    id: 187,
    name: 'Chronograph Perpetual',
    brand: mockBrands[381],
    description: 'Cronógrafo con calendario perpetuo.',
    price: 90000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/chrono-perp-1.jpg', 'https://example.com/chrono-perp-2.jpg'],
    sellerId: 3
  },
  {
    id: 188,
    name: 'Nautilus Travel Time',
    brand: mockBrands[381],
    description: 'Doble huso horario con diseño deportivo.',
    price: 55000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/travel-time-1.jpg', 'https://example.com/travel-time-2.jpg'],
    sellerId: 8
  },
  {
    id: 189,
    name: 'Golden Ellipse',
    brand: mockBrands[381],
    description: 'Forma elíptica con elegancia pura.',
    price: 35000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/ellipse-1.jpg', 'https://example.com/ellipse-2.jpg'],
    sellerId: 5
  },
  {
    id: 190,
    name: 'Sky Moon Tourbillon',
    brand: mockBrands[381],
    description: 'Obra maestra con tourbillon y cielo estrellado.',
    price: 200000,
    condition: 'NEW',
    marketStatus: 'SOLD',
    iconUrl: '',
    images: ['https://example.com/sky-moon-1.jpg', 'https://example.com/sky-moon-2.jpg'],
    sellerId: 10
  },
  {
    id: 191,
    name: 'Submariner Date',
    brand: mockBrands[424],
    description: 'Reloj de buceo icónico y resistente.',
    price: 12000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/submariner-1.jpg', 'https://example.com/submariner-2.jpg'],
    sellerId: 5
  },
  {
    id: 192,
    name: 'Daytona',
    brand: mockBrands[424],
    description: 'Cronógrafo legendario para carreras.',
    price: 18000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/daytona-1.jpg', 'https://example.com/daytona-2.jpg'],
    sellerId: 9
  },
  {
    id: 193,
    name: 'Datejust',
    brand: mockBrands[424],
    description: 'Clásico versátil con fecha ampliada.',
    price: 8000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/datejust-1.jpg', 'https://example.com/datejust-2.jpg'],
    sellerId: 2
  },
  {
    id: 194,
    name: 'GMT-Master II',
    brand: mockBrands[424],
    description: 'Doble huso horario con bisel bicolor.',
    price: 15000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/gmt-master-1.jpg', 'https://example.com/gmt-master-2.jpg'],
    sellerId: 7
  },
  {
    id: 195,
    name: 'Explorer',
    brand: mockBrands[424],
    description: 'Diseño robusto para aventuras.',
    price: 9000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/explorer-1.jpg', 'https://example.com/explorer-2.jpg'],
    sellerId: 1
  },
  {
    id: 196,
    name: 'Sea-Dweller',
    brand: mockBrands[424],
    description: 'Buceo profundo con válvula de helio.',
    price: 14000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/sea-dweller-1.jpg', 'https://example.com/sea-dweller-2.jpg'],
    sellerId: 4
  },
  {
    id: 197,
    name: 'Day-Date',
    brand: mockBrands[424],
    description: 'Lujo con día y fecha en la esfera.',
    price: 25000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/day-date-1.jpg', 'https://example.com/day-date-2.jpg'],
    sellerId: 8
  },
  {
    id: 198,
    name: 'Oyster Perpetual',
    brand: mockBrands[424],
    description: 'Simplicidad y precisión en acero.',
    price: 7000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/oyster-1.jpg', 'https://example.com/oyster-2.jpg'],
    sellerId: 3
  },
  {
    id: 199,
    name: 'Sky-Dweller',
    brand: mockBrands[424],
    description: 'Complicación anual para viajeros.',
    price: 20000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/sky-dweller-1.jpg', 'https://example.com/sky-dweller-2.jpg'],
    sellerId: 6
  },
  {
    id: 200,
    name: 'Yacht-Master',
    brand: mockBrands[424],
    description: 'Náutico de lujo con bisel giratorio.',
    price: 16000,
    condition: 'NEW',
    marketStatus: 'SOLD',
    iconUrl: '',
    images: ['https://example.com/yacht-master-1.jpg', 'https://example.com/yacht-master-2.jpg'],
    sellerId: 10
  },
  {
    id: 201,
    name: '556 I',
    brand: mockBrands[449],
    description: 'Diseño minimalista con gran legibilidad.',
    price: 1500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/556i-1.jpg', 'https://example.com/556i-2.jpg'],
    sellerId: 3
  },
  {
    id: 202,
    name: '104 St Sa',
    brand: mockBrands[449],
    description: 'Reloj piloto clásico y funcional.',
    price: 1800,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/104st-1.jpg', 'https://example.com/104st-2.jpg'],
    sellerId: 8
  },
  {
    id: 203,
    name: 'U1',
    brand: mockBrands[449],
    description: 'Reloj de buceo en acero submarino.',
    price: 2500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/u1-1.jpg', 'https://example.com/u1-2.jpg'],
    sellerId: 1
  },
  {
    id: 204,
    name: 'EZM 3',
    brand: mockBrands[449],
    description: 'Robusto para misiones extremas.',
    price: 2000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/ezm3-1.jpg', 'https://example.com/ezm3-2.jpg'],
    sellerId: 6
  },
  {
    id: 205,
    name: '6060',
    brand: mockBrands[449],
    description: 'Elegancia con triple huso horario.',
    price: 3000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/6060-1.jpg', 'https://example.com/6060-2.jpg'],
    sellerId: 4
  },
  {
    id: 206,
    name: 'UX',
    brand: mockBrands[449],
    description: 'Buceo extremo con tecnología hidráulica.',
    price: 2800,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/ux-1.jpg', 'https://example.com/ux-2.jpg'],
    sellerId: 9
  },
  {
    id: 207,
    name: '857 UTC',
    brand: mockBrands[449],
    description: 'Reloj piloto con segundo huso horario.',
    price: 2200,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/857utc-1.jpg', 'https://example.com/857utc-2.jpg'],
    sellerId: 2
  },
  {
    id: 208,
    name: 'U50',
    brand: mockBrands[449],
    description: 'Compacto y resistente para buceo.',
    price: 3500,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/u50-1.jpg', 'https://example.com/u50-2.jpg'],
    sellerId: 7
  },
  {
    id: 209,
    name: '103 Ti Ar',
    brand: mockBrands[449],
    description: 'Cronógrafo piloto en titanio.',
    price: 4000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/103ti-1.jpg', 'https://example.com/103ti-2.jpg'],
    sellerId: 5
  },
  {
    id: 210,
    name: 'EZM 13',
    brand: mockBrands[449],
    description: 'Cronógrafo técnico para profesionales.',
    price: 3200,
    condition: 'NEW',
    marketStatus: 'SOLD',
    iconUrl: '',
    images: ['https://example.com/ezm13-1.jpg', 'https://example.com/ezm13-2.jpg'],
    sellerId: 10
  },
  {
    id: 211,
    name: 'Carrera Calibre 16',
    brand: mockBrands[466],
    description: 'Cronógrafo deportivo con estilo clásico.',
    price: 3000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/carrera-16-1.jpg', 'https://example.com/carrera-16-2.jpg'],
    sellerId: 6
  },
  {
    id: 212,
    name: 'Monaco',
    brand: mockBrands[466],
    description: 'Diseño cuadrado icónico de carreras.',
    price: 4500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/monaco-1.jpg', 'https://example.com/monaco-2.jpg'],
    sellerId: 1
  },
  {
    id: 213,
    name: 'Aquaracer',
    brand: mockBrands[466],
    description: 'Reloj de buceo versátil y robusto.',
    price: 2000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/aquaracer-1.jpg', 'https://example.com/aquaracer-2.jpg'],
    sellerId: 8
  },
  {
    id: 214,
    name: 'Formula 1',
    brand: mockBrands[466],
    description: 'Inspiración automovilística accesible.',
    price: 1500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/formula-1-1.jpg', 'https://example.com/formula-1-2.jpg'],
    sellerId: 4
  },
  {
    id: 215,
    name: 'Link',
    brand: mockBrands[466],
    description: 'Diseño ergonómico con brazalete distintivo.',
    price: 2500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/link-1.jpg', 'https://example.com/link-2.jpg'],
    sellerId: 9
  },
  {
    id: 216,
    name: 'Carrera Calibre Heuer 02',
    brand: mockBrands[466],
    description: 'Cronógrafo moderno de alta precisión.',
    price: 5000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/carrera-02-1.jpg', 'https://example.com/carrera-02-2.jpg'],
    sellerId: 2
  },
  {
    id: 217,
    name: 'Autavia',
    brand: mockBrands[466],
    description: 'Estilo piloto con toque retro.',
    price: 3500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/autavia-1.jpg', 'https://example.com/autavia-2.jpg'],
    sellerId: 7
  },
  {
    id: 218,
    name: 'Carrera Calibre 1887',
    brand: mockBrands[466],
    description: 'Cronógrafo elegante con movimiento propio.',
    price: 6000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/carrera-1887-1.jpg', 'https://example.com/carrera-1887-2.jpg'],
    sellerId: 3
  },
  {
    id: 219,
    name: 'Monaco Calibre 11',
    brand: mockBrands[466],
    description: 'Edición moderna del clásico Monaco.',
    price: 7000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/monaco-11-1.jpg', 'https://example.com/monaco-11-2.jpg'],
    sellerId: 5
  },
  {
    id: 220,
    name: 'Aquaracer Calibre 5',
    brand: mockBrands[466],
    description: 'Reloj de buceo con acabado premium.',
    price: 3200,
    condition: 'NEW',
    marketStatus: 'SOLD',
    iconUrl: '',
    images: ['https://example.com/aquaracer-5-1.jpg', 'https://example.com/aquaracer-5-2.jpg'],
    sellerId: 10
  },
  {
    id: 221,
    name: 'Black Bay Fifty-Eight',
    brand: mockBrands[489],
    description: 'Reloj de buceo compacto y vintage.',
    price: 3500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/fifty-eight-1.jpg', 'https://example.com/fifty-eight-2.jpg'],
    sellerId: 2
  },
  {
    id: 222,
    name: 'Heritage Chrono',
    brand: mockBrands[489],
    description: 'Cronógrafo con estilo retro.',
    price: 4000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/heritage-chrono-1.jpg', 'https://example.com/heritage-chrono-2.jpg'],
    sellerId: 7
  },
  {
    id: 223,
    name: 'Pelagos',
    brand: mockBrands[489],
    description: 'Buceo profesional en titanio.',
    price: 4500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/pelagos-1.jpg', 'https://example.com/pelagos-2.jpg'],
    sellerId: 4
  },
  {
    id: 224,
    name: 'Black Bay GMT',
    brand: mockBrands[489],
    description: 'Doble huso horario con bisel bicolor.',
    price: 5000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/black-bay-gmt-1.jpg', 'https://example.com/black-bay-gmt-2.jpg'],
    sellerId: 9
  },
  {
    id: 225,
    name: 'Style',
    brand: mockBrands[489],
    description: 'Elegancia clásica asequible.',
    price: 2000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/style-1.jpg', 'https://example.com/style-2.jpg'],
    sellerId: 1
  },
  {
    id: 226,
    name: 'Black Bay Chrono',
    brand: mockBrands[489],
    description: 'Cronógrafo deportivo con gran presencia.',
    price: 5500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/black-bay-chrono-1.jpg', 'https://example.com/black-bay-chrono-2.jpg'],
    sellerId: 6
  },
  {
    id: 227,
    name: 'North Flag',
    brand: mockBrands[489],
    description: 'Diseño robusto para exploradores.',
    price: 3000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/north-flag-1.jpg', 'https://example.com/north-flag-2.jpg'],
    sellerId: 3
  },
  {
    id: 228,
    name: 'Black Bay Bronze',
    brand: mockBrands[489],
    description: 'Bronce patinado con estilo náutico.',
    price: 6000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/bronze-1.jpg', 'https://example.com/bronze-2.jpg'],
    sellerId: 8
  },
  {
    id: 229,
    name: 'Pelagos LHD',
    brand: mockBrands[489],
    description: 'Buceo con corona a la izquierda.',
    price: 7000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/pelagos-lhd-1.jpg', 'https://example.com/pelagos-lhd-2.jpg'],
    sellerId: 5
  },
  {
    id: 230,
    name: 'Black Bay Dark',
    brand: mockBrands[489],
    description: 'Totalmente negro con acabado robusto.',
    price: 5000,
    condition: 'NEW',
    marketStatus: 'SOLD',
    iconUrl: '',
    images: ['https://example.com/dark-1.jpg', 'https://example.com/dark-2.jpg'],
    sellerId: 10
  },
  {
    id: 231,
    name: 'El Primero Chronograph',
    brand: mockBrands[540],
    description: 'Cronógrafo legendario de alta frecuencia.',
    price: 6500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/el-primero-1.jpg', 'https://example.com/el-primero-2.jpg'],
    sellerId: 4
  },
  {
    id: 232,
    name: 'Defy Classic',
    brand: mockBrands[540],
    description: 'Diseño moderno con materiales ligeros.',
    price: 5000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/defy-classic-1.jpg', 'https://example.com/defy-classic-2.jpg'],
    sellerId: 9
  },
  {
    id: 233,
    name: 'Pilot Type 20',
    brand: mockBrands[540],
    description: 'Estilo aviador con esfera grande.',
    price: 6000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/pilot-20-1.jpg', 'https://example.com/pilot-20-2.jpg'],
    sellerId: 2
  },
  {
    id: 234,
    name: 'Elite Ultra Thin',
    brand: mockBrands[540],
    description: 'Elegancia clásica en formato delgado.',
    price: 4500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/elite-1.jpg', 'https://example.com/elite-2.jpg'],
    sellerId: 7
  },
  {
    id: 235,
    name: 'Chronomaster Revival',
    brand: mockBrands[540],
    description: 'Homenaje retro al El Primero.',
    price: 7000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/revival-1.jpg', 'https://example.com/revival-2.jpg'],
    sellerId: 1
  },
  {
    id: 236,
    name: 'Defy 21',
    brand: mockBrands[540],
    description: 'Cronógrafo de alta frecuencia futurista.',
    price: 10000,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/defy-21-1.jpg', 'https://example.com/defy-21-2.jpg'],
    sellerId: 5
  },
  {
    id: 237,
    name: 'Captain Moonphase',
    brand: mockBrands[540],
    description: 'Fases lunares con estilo tradicional.',
    price: 5500,
    condition: 'USED',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['https://example.com/moonphase-1.jpg', 'https://example.com/moonphase-2.jpg'],
    sellerId: 8
  },
  {
    id: 238,
    name: 'El Primero 36’000 VpH',
    brand: mockBrands[540],
    description: 'Cronógrafo preciso con diseño moderno.',
    price: 9000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: [],
    sellerId: 3
  },
  {
    id: 239,
    name: 'Defy Midnight',
    brand: mockBrands[540],
    description: 'Diseño femenino con cielo estrellado.',
    price: 8000,
    condition: 'NEW',
    marketStatus: 'AVAILABLE',
    iconUrl: '',
    images: ['http://localhost:3000/watches/1.jpg'],
    sellerId: 6
  },
  {
    id: 240,
    name: 'Pilot Doublematic',
    brand: mockBrands[540],
    description: `Descubre el X10 Pro, un reloj inteligente diseñado para quienes buscan elegancia y tecnología en un solo dispositivo.
  Con una pantalla AMOLED de 1.4", monitoreo de frecuencia cardíaca en tiempo real y resistencia al agua IP68,
  este reloj es ideal para el día a día y el deporte. Además, cuenta con notificaciones inteligentes, control de música
  y una batería de hasta 10 días de duración.`,
    price: 11000,
    condition: 'NEW',
    marketStatus: 'SOLD',
    iconUrl: '',
    images: ['http://localhost:3000/watches/1.jpg', 'http://localhost:3000/watches/2.jpg','http://localhost:3000/watches/3.jpeg'],
    sellerId: 10
  }
];
